import React, { useState } from 'react';

import GatePassTab from './GatePassTab';

const SUB_TABS = [

  { id: 'outward', label: '↑ Outward (Gate Pass)' },
];

const SalesTab = () => {
  const [active, setActive] = useState('outward');

  return (
    <div>
      <div style={styles.subTabBar}>
        {SUB_TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setActive(t.id)}
            style={{ ...styles.subTab, ...(active === t.id ? styles.subTabActive : {}) }}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div>
        
        {active === 'outward' && <GatePassTab lockDirection="outward" />}
      </div>
    </div>
  );
};

const styles = {
  subTabBar: {
    display: 'flex',
    gap: '4px',
    padding: '0 30px',
    borderBottom: '2px solid #f0f0f0',
    background: '#f0f9f4',
  },
  subTab: {
    padding: '14px 22px',
    background: 'transparent',
    border: 'none',
    borderBottom: '3px solid transparent',
    marginBottom: '-2px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 600,
    color: '#7f8c8d',
  },
  subTabActive: {
    color: '#27ae60',
    borderBottom: '3px solid #27ae60',
  },
};

export default SalesTab;